import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroupDirective } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericDialogComponent } from '../../shared/generic-dialog/generic-dialog.component';
import { RemoveDialogComponent } from '../remove-dialog/remove-dialog.component';
import { LanguageService } from '../../shared/services/language.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { AuthService } from '../../shared/services/auth.service';
import { CatalogDialogComponent } from '../catalog-dialog/catalog-dialog.component';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { Profile } from 'src/app/models/Profile';
import { Permission } from '../../shared/security/permission';


@Component({
  standalone: false,
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.css']
})
export class CatalogComponent implements OnInit {

  Permission = Permission;
  variables: any;
  arr1: any = [];
  // Form and sub form, needed to link parent form with this component form.
  form: any;
  subForm: any;

  dragDisabled = true;

  @Input() listItemActions: any = []//List of action type choosen by the user.
  @Input() canEditCatalog: boolean = false;
  @Input() profiles: Profile[] = [];

  listActionByType: any = []; //List of action items filtered by type

  preDefinedActions: any = []; // List of pre-defined action items
  alreadyInCatalog: any[] = []; //List of tasks already in catalog

  constructor(
    private _formBuilder: FormBuilder,
    public authService: AuthService,
    private ctrlContainer: FormGroupDirective,
    private dialog: MatDialog,
    private router: Router,
    private infoBar: InfoBarWithStatusService,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private _snackBar: MatSnackBar,
    private UsersManagementService: UsersManagementService,
  ) { }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
      this.preDefinedActions = [
        { name: this.variables.createUserInterfaces },
        { name: this.variables.developRestApis },
        { name: this.variables.developSoapApis },
        { name: this.variables.createRelationalDatabase },
        { name: this.variables.createNonRelationalDatabase },
        { name: this.variables.createTableDatabase },
        { name: this.variables.createProceduresTrigers },
        { name: this.variables.createIntegrationDatabases },
        { name: this.variables.other }
      ];
    });


    //Link sub form and form
    this.subForm = this._formBuilder.group({
      projectType: [''],
    });

    this.form = this.ctrlContainer.form;
    this.form.addControl("formGroup6", this.subForm)

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.listItemActions?.currentValue)
      this.alreadyInCatalog = changes.listItemActions.currentValue
  }

  openDialogProject() {
    var arrAll;
    this.arr1 = [];
    arrAll = this.listItemActions;

    if (arrAll && arrAll.length != 0) {
      for (var i = 0; i < arrAll.length; i++) {
        this.arr1.push(arrAll[i].name);
      }
    }

    // Prepare data to be passed to dialog component
    const data = {
      title: this.variables.addTask,
      list: this.preDefinedActions,
      isEdit: false,
      listInDB: this.alreadyInCatalog,
      effort: this.variables.hours,
      isActionType: true,
      profiles: this.profiles,
    }
    let dialogRef = this.dialog.open(CatalogDialogComponent, {
      width: '700px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {

      //Add item to array
      if (result) {

        if (this.arr1.includes(result.data.name)) {
          this._snackBar.open(this.variables.snackBarErrorAddAction);
        }
        else {
          const Action = {
            name: result.data.name,
            complexityLow: result.data.complexityLow.toFixed(2),
            complexityMedium: result.data.complexityMedium.toFixed(2),
            complexityHigh: result.data.complexityHigh.toFixed(2),
            detailsLow: result.data.detailsLowCtrl,
            detailsMedium: result.data.detailsMedCtrl,
            detailsHigh: result.data.detailsHighCtrl,
            tshirtXS: result.data.tshirtXS,
            tshirtS: result.data.tshirtS,
            tshirtM: result.data.tshirtM,
            tshirtL: result.data.tshirtL,
            tshirtXL: result.data.tshirtXL,
            tshirtXXL: result.data.tshirtXXL,
            profileId: result.data.profileId || null,
          }
          if (!this.listItemActions) {
            this.listItemActions = [];
          }
          this.listItemActions.push(Action);
        }
      }
    })
  }


  openDialogEditProject(item: any) {
    var arrAll;
    this.arr1 = [];
    arrAll = this.listItemActions;

    for (var i = 0; i < arrAll.length; i++) {
      this.arr1.push(arrAll[i].name);
    }

    const index = this.arr1.indexOf(item.name);
    if (index !== -1) {
      this.arr1.splice(index, 1);
    } else {
    }

    //Prepare data to be passed to dialog component
    item.title = this.variables.changeTask + ': ' + item.name

    const data = {
      title: item.title,
      list: this.preDefinedActions,
      listInDB: this.alreadyInCatalog,
      item: item,
      effort: this.variables.hours,
      isActionType: true,
      isEdit: true,
      profiles: this.profiles,
    }

    let dialogRef = this.dialog.open(CatalogDialogComponent, {
      width: '700px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {

      // Get result and update item on the arr
      if (result?.data) {

        if (this.arr1.includes(result.data.name)) {
          this._snackBar.open(this.variables.snackBarErrorEditAction);
        }
        else {
          this.listItemActions.forEach((v: any) => {
            if (v.name === item.name && v.complexityLow === item.complexityLow && v.complexityMedium === item.complexityMedium && v.complexityHigh === item.complexityHigh &&
              v.detailsLow === item.detailsLow && v.detailsMed === item.detailsMed && v.detailsHigh === item.detailsHigh &&
              v.tshirtXS === item.tshirtXS && v.tshirtS === item.tshirtS && v.tshirtM === item.tshirtM && v.tshirtL === item.tshirtL &&
              v.tshirtXL === item.tshirtXL && v.tshirtXXL === item.tshirtXXL
            ) {
              v.name = result.data.name;
              v.complexityLow = result.data.complexityLow;
              v.complexityMedium = result.data.complexityMedium;
              v.complexityHigh = result.data.complexityHigh;
              v.detailsLow = result.data.detailsLowCtrl;
              v.detailsMedium = result.data.detailsMedCtrl;
              v.detailsHigh = result.data.detailsHighCtrl;
              v.tshirtXS = result.data.tshirtXS;
              v.tshirtS = result.data.tshirtS;
              v.tshirtM = result.data.tshirtM;
              v.tshirtL = result.data.tshirtL;
              v.tshirtXL = result.data.tshirtXL;
              v.tshirtXXL = result.data.tshirtXXL;
              v.profileId = result.data.profileId || null;
            }
          })
          this.infoBar.showSnackbar(this.variables.taskEditedSuccessfully, ['successful-snackbar'], 4000);
        }

      }

    })
  }


  openDialogRemove(name: string) {
    let dialogRef = this.dialog.open(RemoveDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      // Remove item
      if (result === 'true') {
        this.listItemActions = this.listItemActions.filter((item: any) => {
          return item.name != name;
        })
        this.infoBar.showSnackbar(this.variables.taskRemovedSuccessfully, ['successful-snackbar'], 4000);
      }
    });
  }

  dropTable(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.listItemActions, event.previousIndex, event.currentIndex);
  }


  leave() {
    // Set message for pop up
    let local_data = {
      message: this.variables.sureOutMesage
    }
    // Open pop up
    let dialogRef = this.dialog.open(GenericDialogComponent, {
      data: local_data
    });

    dialogRef.afterClosed().subscribe(result => {

      //Leave backoffice catalog
      if (result.data) {
        this.router.navigate(['/dashboard']);
      }

    });
  }

  getProfileName(profileId: string): string {
    if (!profileId) return '-';
    const profile = this.profiles.find(p => p.id === profileId);
    return profile ? profile.name : '-';
  }
}
